import React from "react";

class KPIMetricBlock extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() { }

  render() {
    const goodOrBadText = this.props.negative ? "text-danger" : "text-success";
    const goodOrBadBg = this.props.negative ? "bg-danger" : "bg-success";
    return (
      <div className="metric-block m-1 m-3-sm d-inline-block">
        <div className="metric-block-name">{this.props.metricName}</div>
        <div className={`metric-block-number ${goodOrBadText}`}>{this.props.metric}</div>
        <div className={`mt-3 metric-block-yy ${goodOrBadBg}`}>{this.props.yy}</div>
      </div>
    );
  }
}

export default KPIMetricBlock;
